goog.provide('el8.app.settings.settingsNav');
goog.require('el8.app.settings.accountDetailsReactTab');
goog.require('el8.app.settings.appPrefs');
goog.require('el8.app.settings.billing');
goog.require('el8.app.settings.calendarAndBooking');
goog.require('el8.app.settings.careTeamSharing');
goog.require('el8.app.settings.ccda');
goog.require('el8.app.settings.docTags');
goog.require('el8.app.settings.epcsSettings');
goog.require('el8.app.settings.faxUsageAndSettings');
goog.require('el8.app.settings.idProofing');
goog.require('el8.app.settings.letterRouting');
goog.require('el8.app.settings.memberships')
goog.require('el8.app.settings.patientTags');
goog.require('el8.app.settings.patientForms');
goog.require('el8.app.settings.manageAccounts');
goog.require('el8.app.settings.practiceLocations');
goog.require('el8.app.settings.prescriptions');
goog.require('el8.app.settings.printHeaders');
goog.require('el8.app.settings.ptPassportDefaults');
goog.require('el8.app.settings.schedule');
goog.require('el8.app.settings.securityPrivacy');
goog.require('el8.app.settings.sortSettings');
goog.require('el8.app.settings.staffDelegates');
goog.require('el8.app.settings.staffDisplaySettings');
goog.require('el8.app.settings.staffGroups');
goog.require('el8.app.settings.staffGroupDelegates');
goog.require('el8.app.settings.stripeIntegration');
goog.require('el8.app.settings.telehealth');
goog.require('el8.app.settings.templates');
goog.require('el8.app.settings.labOrders');
goog.require('el8.app.settings.labVendors');
goog.require('el8.app.settings.typeSettings');
goog.require('el8.app.settings.templatesSettings');
goog.require('el8.app.settings.insurance');
goog.require('el8.app.settings.multipracticeLinkedAccounts');
goog.require('el8.app.settings.workspaces');
goog.require('el8.template.app.settings.sections');
goog.require('el8.uiwidget.GroupedNav');
goog.require('el8.util.amplitude.helpers');


el8.app.settings.settingsNav.groupedNav = null;

/**
 * This is the top-level file that manages all the other components
 * of the settings page. It creates the navigation (vertical tabs)
 * using the GroupedNav widget, and each tab generally corresponds
 * to a separate file that manages its components.
 */
el8.app.settings.settingsNav.init = function(defaultTab) {
  var isPoppingState = false;
  var updateBrowserUrl = function($container, name) {
    // if we push state while already popping state,
    // we will build up a stack of the same tab over and over
    if (isPoppingState) {
      return;
    }

    var path = name + '/';
    var historyState = { tab: name, query: window.location.search };

    var url = '/settings/' + path + window.location.hash;
    window.history.pushState(historyState, 'Settings - Elation EMR', url);
  };

  function addReactTab(opts) {
    var name = opts.name;
    var label = opts.label;
    var pathName = opts.pathName;
    var options = opts.options;
    var onShow = opts.onShow;

    return $.extend({}, {
      name: name,
      label: label,
      initFn: function($container) {
        el8.app.settings[pathName].init($container);
      },
      showFn: function($container, name) {
        el8.app.settings[pathName].showTabFn($container);
        updateBrowserUrl($container, name);
        if (onShow) {
          onShow();
        }
      },
      hideFn: function($container) {
        el8.app.settings[pathName].hideTabFn($container);
      }
    }, options);
  }

  el8.app.settings.settingsNav.groupedNav = new el8.uiwidget.GroupedNav({
    navContainer: $('#settings-nav'),
    contentContainer: $('#settings-content')
  });

  var groupedNav = el8.app.settings.settingsNav.groupedNav;

  var groups;
  var flatListOfPages = [];

  if(!el8Globals.FEATURES.SettingsNavBar) {
   groups = [
    {
      title: 'User Settings',
      sections: [
        (addReactTab({
          name: 'useraccount',
          label: 'Account Details',
          pathName: 'accountDetailsReactTab'
        }))
      ]
    },
    {
      title: 'Practice Settings',
      sections: [
        addReactTab({
          name: 'billing',
          label: 'Billing',
          pathName: 'billing'
        }),
        addReactTab({
          name: 'practice-locations',
          label: 'Practice Locations',
          pathName: 'practiceLocations'
        }),
        {
          name: 'insurance',
          label: 'Insurance',
          initFn: function($container) {
            el8.app.settings.insurance.init($container)
          },
          showFn: function($container, name) {
            el8.app.settings.insurance.showTabFn();
            updateBrowserUrl($container, name);
          },
          hideFn: function($container) {
            el8.app.settings.insurance.hideTabFn();
          }
        },
        {
          name: 'headers',
          label: 'Print Headers',
          initFn: function($container) {
            el8.app.settings.printHeaders.init($container);
          }
        },
        {
          name: 'staff-display',
          label: 'Clinical Care Measure Settings',
          initFn: function($container) {
            el8.app.settings.staffDisplaySettings.init($container);
          }
        },
        {
          name: 'usage',
          label: 'Fax Usage & Settings',
          initFn: function($container) {
            el8.app.settings.faxUsageAndSettings.init($container);
          }
        },
        addReactTab({
          name: 'templates',
          label: 'Templates',
          pathName: 'templatesSettings'
        }),
        {
          name: 'doc-tags',
          label: 'Document Tags',
          initFn: function($container) {
            el8.app.settings.docTags.init($container);
          }
        },
        {
          name: 'patient-tags',
          label: 'Patient Tags',
          initFn: function($container) {
            el8.app.settings.patientTags.init($container);
          }
        },
        addReactTab({ name: 'prescriptions', label: 'Prescriptions', pathName: 'prescriptions' }),
        addReactTab({ name: 'sort', label: 'Sort Settings', pathName: 'sortSettings' }),
      ]
    }
  ];

  if (el8Globals.FEATURES.AdminManagedSettings) {
    if (!el8.data.currUser.isPracticeAdmin()) {
      var indexOfClinicalCare = groups[1].sections.map(function(obj) {return obj.name}).indexOf("staff-display")
      groups[1].sections.splice(indexOfClinicalCare, 1)
      var indexOfFaxUsage = groups[1].sections.map(function(obj) {return obj.name}).indexOf("usage")
      groups[1].sections.splice(indexOfFaxUsage, 1)
    }
  }

  if (el8Globals.FEATURES.PracticeStripeInt) {
    if (el8Globals.FEATURES.PracticeMemberships) {
      groups[1].sections.splice(1, 0,addReactTab({
        name: 'memberships',
        label: 'Membership Management',
        pathName: 'memberships',
        onShow: function onShow() {
          el8.util.amplitude.logEvent('Memberships - view membership settings');
        },
        options: {
          isNew: true
        }
      }));
    }

    groups[1].sections.splice(1, 0, addReactTab({
      name: 'stripe-integration',
      label: 'Patient Payments',
      pathName: 'stripeIntegration',
      options: {
        isNew: true,
      }
    }));
  }

  groups[1].sections.push(
    addReactTab({
      name: 'labs',
      label: 'Labs',
      pathName: 'labVendors'
    })
  );

  groups[1].sections.push(addReactTab({
    name: 'laborders',
    label: "Lab Orders",
    pathName: 'labOrders'
  }));

  if (el8.data.currUser.isPhysician()) {
    groups[0].sections.push({
      name: 'appprefs',
      label: 'Preferences',
      initFn: function($container) {
        el8.app.settings.appPrefs.init($container);
      }
    });
    if (!el8.data.currUser.getRxDelegatingPhysicianIdsInWorkspace().length) {
      // physicians who are delegates of other physicians should not themselves have delegates
      groups[0].sections.push({
        name: 'delegates',
        label: 'Provider Managed Delegates',
        initFn: function($container) {
          el8.app.settings.staffDelegates.init($container);
        }
      });
    }
    if (el8Globals.FEATURES.PatientPortal) {
      groups[0].sections.push(
        addReactTab({
          name: 'patientpassport',
          label: 'Patient Sharing Defaults',
          pathName: 'ptPassportDefaults'
        })
      );
    }
    if (el8Globals.FEATURES.GoogleCalendarSync) {
      groups[0].sections.push(
        addReactTab({
          name: 'google-calendar-sync',
          label: 'Google Calendar Sync',
          pathName: 'schedule'
        })
      );
    }
  }

  if (el8Globals.FEATURES.ContextSwitcher) {
    groups[0].sections.push(
      addReactTab({
          name: 'multipractice-linked-accounts',
          label: 'Linked Accounts',
          pathName: 'multipracticeLinkedAccounts',
          options: {
            isNew: true,
          }
      })
    );
  }

  groups[1].sections.push(
    addReactTab({
      name: 'calendar-and-booking',
      label: 'Calendar & Booking',
      pathName: 'calendarAndBooking',
      options: {
        showFn: function ($container, name) {
          el8.app.settings.calendarAndBooking.showTabFn($container);
          var tabUrlRegex = /^\/settings\/calendar-and-booking\/.+/
          var defaultTabUrl = '/settings/calendar-and-booking/appointments'

          // We use navigate, to actually tell @reach/router, that url had been changed and trigger
          // view change
          var toPath = tabUrlRegex.test(window.location.pathname) ? window.location.pathname : defaultTabUrl;
          el8React.navigate(toPath, {
            state: {
              tab: 'calendar-and-booking',
              query: ''
            },
            replace: isPoppingState
          });
        }
      }
    })
  );

  groups[1].sections.push(addReactTab({
    name: 'telehealth',
    label: 'Virtual Visits',
    pathName: 'telehealth',
    options: {
      isNew: true,
    }
  }));

  groups[1].sections.push(
    addReactTab({
      name: 'patient-forms',
      label: 'Patient Forms',
      pathName: 'patientForms',
      options: {
        showFn: function ($container, name) {
          el8.app.settings.patientForms.showTabFn($container);
          var tabUrlRegex = /^\/settings\/patient-forms\/.+/
          var defaultTabUrl = '/settings/patient-forms'

          // We use navigate, to actually tell @reach/router, that url had been changed and trigger
          // view change
          var toPath = tabUrlRegex.test(window.location.pathname) ? window.location.pathname : defaultTabUrl;
          el8React.navigate(toPath, {
            state: {
              tab: 'patient-forms',
              query: ''
            },
            replace: isPoppingState
          });
        }
      }
    })
  );

  if (el8Globals.FEATURES.CCDAPreferences) {
    groups[1].sections.push(
      addReactTab({
        name: 'ccda-preferences',
        label: 'CCDA Preferences',
        pathName: 'ccda'
      })
    );
  }

  if (el8Globals.FEATURES.PLR4Everyone) {
    groups[1].sections.push(
      addReactTab({
        name: 'care-team-sharing',
        label: 'Collaborative View Sharing',
        pathName: 'careTeamSharing'
      })
    );
  }
  if(el8.data.currUser.isPracticeAdmin() && el8Globals.FEATURES.Workspaces){
    groups[1].sections.push(
      addReactTab({
        name: 'workspaces',
        label: 'Workspaces',
        pathName: 'workspaces',
        options: {
          showFn: function ($container, name) {
            el8.app.settings.workspaces.showTabFn($container);
            var tabUrlRegex = /^\/settings\/workspaces\/.+/
            var defaultTabUrl = '/settings/workspaces'

            // We use navigate, to actually tell @reach/router, that url had been changed and trigger
            // view change
            var toPath = tabUrlRegex.test(window.location.pathname) ? window.location.pathname : defaultTabUrl;
            el8React.navigate(toPath, {
              state: {
                tab: 'workspaces',
                query: ''
              },
              replace: isPoppingState
            });
          }
        }
      })
    );
  }

  if (el8Globals.FEATURES.MDToolboxEPCS) {
    var sections = [
      {
        name: 'epcs-settings',
        label: 'ePrescribing Controlled Substances (EPCS)',
        showFn: function($container, name) {
          // no initFn: function
          el8.app.settings.epcsSettings.showTabFn($container);
          updateBrowserUrl($container, name);
        }
      }
    ];

    groups.push({
      title: 'Other Settings',
      sections: sections
    });
  }

  if (el8.data.currUser.isPracticeAdmin()) {
    var sections = [];
      sections.push(addReactTab({
        name: 'allaccounts',
        label: 'Manage Accounts',
        pathName: 'manageAccounts'
      }))


    sections.push(
      {
        name: 'staffgroups',
        label: 'User Groups',
        initFn: function($container) {
          el8.app.settings.staffGroups.init($container);
        }
      }
    );

    if (el8Globals.FEATURES.StaffGroupDelegates) {
      sections.push(addReactTab({
        name: 'staff-group-delegates',
        label: 'Admin Managed Delegates',
        pathName: 'staffGroupDelegates'
      }));
    }

    sections.push({
      name: 'typesettings',
      label: 'Report & Visit Note Categories',
      initFn: function($container) {
        el8.app.settings.typeSettings.init($container);
      }
    });

    if (el8Globals.FEATURES.ReactPtPassportMsgs) {
      sections.push(addReactTab({
          name: 'letter-routing',
          label: 'Patient Passport Messages',
          pathName: 'letterRoutingReact',
        })
      );
    } else {
      sections.push({
        name: 'letter-routing',
        label: 'Patient Passport Messages',
        initFn: function($container) {
          el8.app.settings.letterRouting.init($container);
        }
      });
    }

      sections.push(addReactTab({
        name: 'security-privacy',
        label: 'Security & Privacy',
        pathName: 'securityPrivacy',
        onShow: function onShow() {
          el8.util.amplitude.logEvent('view security and privacy settings');
        }
      }));


    groups.push({
      title: 'Admin Users Only',
      sections: sections
    });
  }
  }
  else {

    groups = [{
      title: 'Your Account',
      sections: [
        addReactTab({
          name: 'useraccount',
          label: 'Account Details',
          pathName: 'accountDetailsReactTab',
        }),
      ]
    }];

    if (el8Globals.FEATURES.ContextSwitcher )
      {
        groups[0].sections.push(addReactTab({
          name: 'multipractice-linked-accounts',
          label: 'Linked Accounts',
          pathName: 'multipracticeLinkedAccounts',
          options: {
            isNew: true,
          }
      }));
    }

    if(el8.data.currUser.isPhysician()) {
      groups[0].sections.push({name: 'appprefs',
        label: 'Preferences',
        initFn: function($container) {
          el8.app.settings.appPrefs.init($container);
        }
      });

      if(!el8.data.currUser.getRxDelegatingPhysicianIdsInWorkspace().length) {
        // physicians who are delegates of other physicians should not themselves have delegates
        groups[0].sections.push({name: 'delegates',
        label: 'Provider Managed Delegates',
        initFn: function($container) {
          el8.app.settings.staffDelegates.init($container);
        }});
      }
    }

  // Your Organization section, groups[1]
    groups.push({
      title: "Your Organization",
      sections: []
    });

    if(el8.data.currUser.isPracticeAdmin())  {
      if(el8Globals.FEATURES.StaffGroupDelegates)  {
        groups[1].sections.push(addReactTab({
          name: 'staff-group-delegates',
          label: 'Admin Managed Delegates',
          pathName: 'staffGroupDelegates'
        }));
      }
      groups[1].sections.push(addReactTab({
        name: 'allaccounts',
        label: 'Manage Accounts',
        pathName: 'manageAccounts'
      }))
    }
    groups[1].sections.push(addReactTab({
      name: 'practice-locations',
      label: 'Practice Locations',
      pathName: 'practiceLocations'
    }));
    if (el8.data.currUser.isPracticeAdmin())  {
      groups[1].sections.push(addReactTab({
        name: 'security-privacy',
        label: 'Security & Privacy',
        pathName: 'securityPrivacy',
        onShow: function onShow() {
          el8.util.amplitude.logEvent('view security and privacy settings');
        }
      }));
    }
    if (el8.data.currUser.isPracticeAdmin())
    {
      groups[1].sections.push({name: 'staffgroups',
      label: 'User Groups',
      initFn: function($container) {
        el8.app.settings.staffGroups.init($container);
      }})
    }
    if (el8.data.currUser.isPracticeAdmin() && el8Globals.FEATURES.Workspaces)
    {
      groups[1].sections.push(addReactTab({
        name: 'workspaces',
        label: 'Workspaces',
        pathName: 'workspaces',
        options: {
          showFn: function ($container, name) {
            el8.app.settings.workspaces.showTabFn($container);
            var tabUrlRegex = /^\/settings\/workspaces\/.+/
            var defaultTabUrl = '/settings/workspaces'

            // We use navigate, to actually tell @reach/router, that url had been changed and trigger
            // view change
            var toPath = tabUrlRegex.test(window.location.pathname) ? window.location.pathname : defaultTabUrl;
            el8React.navigate(toPath, {
              state: {
                tab: 'workspaces',
                query: ''
              },
              replace: isPoppingState
            });
          }
        }
      }));
    }

    // Practice Operations section, groups[2]
    groups.push({
      title: "Practice Operations",
      sections: [
        addReactTab({
          name: 'billing',
          label: 'Billing',
          pathName: 'billing'
        }),
        addReactTab({
          name: 'calendar-and-booking',
          label: 'Calendar & Booking',
          pathName: 'calendarAndBooking',
          options: {
            showFn: function ($container, name) {
              el8.app.settings.calendarAndBooking.showTabFn($container);
              var tabUrlRegex = /^\/settings\/calendar-and-booking\/.+/
              var defaultTabUrl = '/settings/calendar-and-booking/appointments'

              // We use navigate, to actually tell @reach/router, that url had been changed and trigger
              // view change
              var toPath = tabUrlRegex.test(window.location.pathname) ? window.location.pathname : defaultTabUrl;
              el8React.navigate(toPath, {
                state: {
                  tab: 'calendar-and-booking',
                  query: ''
                },
                replace: isPoppingState
              });
            }
          }
        })
        ]
    });

    if (el8.data.currUser.isPracticeAdmin() || !el8Globals.FEATURES.AdminManagedSettings) {
      groups[2].sections.push({
        name: 'usage',
        label: 'Fax Usage & Settings',
        initFn: function($container) {
          el8.app.settings.faxUsageAndSettings.init($container);
        }
      });
    }

    groups[2].sections.push({
      name: 'insurance',
      label: 'Insurance',
      initFn: function($container) {
        el8.app.settings.insurance.init($container)
      },
      showFn: function($container, name) {
        el8.app.settings.insurance.showTabFn();
        updateBrowserUrl($container, name);
      },
      hideFn: function($container) {
        el8.app.settings.insurance.hideTabFn();
      }
    });

    if (el8Globals.FEATURES.PracticeStripeInt) {
      if (el8Globals.FEATURES.PracticeMemberships) {
        groups[2].sections.push(addReactTab({
          name: 'memberships',
          label: 'Membership Management',
          pathName: 'memberships',
          onShow: function onShow() {
            el8.util.amplitude.logEvent('Memberships - view membership settings');
          },
          options: {
            isNew: true
          }
        }))}
        groups[2].sections.push(addReactTab({
          name: 'stripe-integration',
          label: 'Patient Payments',
          pathName: 'stripeIntegration',
          options: {
            isNew: true,
        }
      }))
    }
    groups[2].sections.push({
      name: 'headers',
      label: 'Print Headers',
      initFn: function($container) {
        el8.app.settings.printHeaders.init($container);
    }});

    groups[2].sections.push(addReactTab({
      name: 'telehealth',
      label: 'Virtual Visits',
      pathName: 'telehealth',
      options: {
        isNew: true,
      }
    }));

    // Clinical Operations section, groups[3]
    groups.push({
      title: "Clinical Operations",
      sections: []
    });

    if (el8.data.currUser.isPracticeAdmin() || !el8Globals.FEATURES.AdminManagedSettings) {
      groups[3].sections.push({
        name: 'staff-display',
        label: 'Clinical Care Measure Settings',
        initFn: function($container) {
          el8.app.settings.staffDisplaySettings.init($container);
        }
      });
    }

    if (el8Globals.FEATURES.CCDAPreferences) {
      groups[3].sections.push(addReactTab({
        name: 'ccda-preferences',
        label: 'CCDA Preferences',
        pathName: 'ccda'
      }));
    }
    if  (el8Globals.FEATURES.PLR4Everyone){
      groups[3].sections.push(addReactTab({
        name: 'care-team-sharing',
        label: 'Collaborative View Sharing',
        pathName: 'careTeamSharing'
      }));
    }
    groups[3].sections.push( {
      name: 'doc-tags',
      label: 'Document Tags',
      initFn: function($container) {
        el8.app.settings.docTags.init($container);
      }
    });
    if (el8Globals.FEATURES.MDToolboxEPCS){
      groups[3].sections.push({
        name: 'epcs-settings',
        label: 'ePrescribing Controlled Substances (EPCS)',
        showFn: function($container, name) {
          // no initFn: function
          el8.app.settings.epcsSettings.showTabFn($container);
          updateBrowserUrl($container, name);
        }
      });
    }
    groups[3].sections.push(
      addReactTab({
        name: 'labs',
        label: 'Labs',
        pathName: 'labVendors'
      }),
      addReactTab({
        name: 'laborders',
        label: "Lab Orders",
        pathName: 'labOrders'
      }),
      addReactTab({
        name: 'patient-forms',
        label: 'Patient Forms',
        pathName: 'patientForms',
        options: {
          showFn: function ($container, name) {
            el8.app.settings.patientForms.showTabFn($container);
            var tabUrlRegex = /^\/settings\/patient-forms\/.+/
            var defaultTabUrl = '/settings/patient-forms'

            // We use navigate, to actually tell @reach/router, that url had been changed and trigger
            // view change
            var toPath = tabUrlRegex.test(window.location.pathname) ? window.location.pathname : defaultTabUrl;
            el8React.navigate(toPath, {
              state: {
                tab: 'patient-forms',
                query: ''
              },
              replace: isPoppingState
            });
          }
        }
      }),
      {
        name: 'patient-tags',
        label: 'Patient Tags',
        initFn: function($container) {
          el8.app.settings.patientTags.init($container);
        }
      },
      addReactTab({
        name: 'prescriptions',
        label: 'Prescriptions',
        pathName: 'prescriptions'
      })
    );
    if(el8.data.currUser.isPracticeAdmin()) {
      groups[3].sections.push(
        {
          name: 'typesettings',
          label: 'Report & Visit Note Categories',
          initFn: function($container) {
            el8.app.settings.typeSettings.init($container);
          }
        }
      );
    }
    groups[3].sections.push(addReactTab({
      name: 'sort',
      label: 'Sort Settings',
      pathName: 'sortSettings'
    }),
      addReactTab({
        name: 'templates',
        label: 'Templates',
        pathName: 'templatesSettings'
      })
    );

  // Patient Communications section, groups[4]
    groups.push({
      title: "Patient Communications",
      sections: []
    })

    if (el8.data.currUser.isPracticeAdmin()) {
      groups[4].sections.push({
        name: 'letter-routing',
        label: 'Patient Passport Messages',
        initFn: function($container) {
          el8.app.settings.letterRouting.init($container);
        }
      });
    }
    if(el8Globals.FEATURES.PatientPortal){
      groups[4].sections.push(addReactTab({
        name: 'patientpassport',
        label: 'Patient Sharing Defaults',
        pathName: 'ptPassportDefaults'
      })
    )}
  }
  // define a default showFn (updateBrowserUrl) for every section
  // that hasn't manually defined a showFn
  groups.forEach(function(group) {
    group.sections.forEach(function(section) {
      flatListOfPages.push(section)
      if (!section.showFn) {
        section.showFn = updateBrowserUrl;
      }
    });
  });

  groupedNav.init({ groups: groups });

  defaultTab = defaultTab || 'useraccount';
  if (groupedNav.hasSection(defaultTab)) {
    groupedNav.showSection(defaultTab);
  } else {
    groupedNav.showSection('useraccount');
  }

  window.onpopstate = function(event) {
    isPoppingState = true;
    if (event.state && event.state.tab) {
      groupedNav.showSection(event.state.tab);
    } else {
      // Settings pages with reach-router will have nested routes
      // that do not have the `state.tab` info in the history
      // unless explicitly set. This is an alternative method
      // for finding the appropriate settings page from the current
      // path that works for more use-cases.
      var path = window.location.pathname;
      var targetPage = _.find(flatListOfPages, function (page) {
        return path.indexOf(page.name) !== -1;
      });
      if (targetPage) {
        groupedNav.showSection(targetPage.name);
      }
    }
    isPoppingState = false;
  };
};
